module.exports = {
  "id": "chase",
  "color": "green",
  "title": "chase",
  "icon": "chase",
  "category": "movement",
  "info": [
    {
      "text": "Make one piece chase another",
      "image": "provision/glitches/chase/chase.gif"
    }
  ],
  "searchTags": ["follow","tag","pursue","after","hunt"],
  "exposedVariables": [
    {
      "type": "sprite",
      "value": "none",
      "variableName": "piece to chase",
      "spriteName": "$glitch_target",
      "tooltip":"Set which piece will be chased",
      "input": {
        "type": "sprite"
      }
    },
    {
      "value": "2",
      "variableName": "chasing speed",
      "spriteName": "$glitch_target",
      "tooltip":"Set the speed the piece will chase the other piece",
      "input": {
        "type": "slider",
        "min": -10,
        "max": 10
      }
    }
  ],
  "codeImage": "provision/glitches/chase/chase.png",
  "code": null,
  "zip": null,
  "sb3": null
};